// extracted by mini-css-extract-plugin
module.exports = {"notAvailablePage":"iFjXkawK","container":"__8h99Pkny","ic":"yCsKJd8n","redirect":"zhf3ynM4","changArea":"NngNm7ho"};